<template>
  <div id="app">
    <v-dialog v-model="linkDialog" @keydown.esc="cancel" max-width="400" persistent scrollable>
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Use o link para visualizar a dashboard
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap justify-center align-center>
            <v-flex xs12>
              <v-tooltip top>
                <v-text-field append-icon="file_copy" slot="activator" readonly name="link" id="link" label="link" type="text" :value="link" @click="copy"  messages="Esse link já possui os filtros da dashboard selecionados"/>
                <span>Clique para copiar</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat @click.native="cancel">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container fluid grid-list-md>
      <v-layout wrap align-left>
        <v-flex xs12 md2>
          <v-select label="Período" v-model="period" :items="dashboard_filter" @input="changePeriod(period, true)">
            <template slot='selection' slot-scope='{ item }'>
              {{ item.text !== 'Período' ? item.text : dashboard_movements.begin !== '' ? (dashboard_movements.end !== '' ? (moment(dashboard_movements.begin).format('DD/MM/YYYY HH:mm') + ' Até ' + moment(dashboard_movements.end).format('DD/MM/YYYY HH:mm')) : ('Desde ' + moment(dashboard_movements.begin).format('DD/MM/YYYY HH:mm'))) : ('Até ' + moment(dashboard_movements.end).format('DD/MM/YYYY HH:mm'))}}
            </template>
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <p-filter
            ref="filter"
            entity="dashboard_movements"
            :allItems="[]"
            info="Os administradores da empresa consegue visualizar a dashboard de todos os usuários da empresa, os demais conseguem ver a dashboard com os próprios dados ou de acordo com as equipes as quais são responsáveis"
            :doFilter="false"
            :filterTypes="filterTypes"
            @beforeCustomFilter="beforeCustomFilter()"
            @customFilter="loadingCards(true)"
            @clickActivator="clickActivatorFilter"
            @blur_teams="(val) => {changeTeams(val)}"
            @afterChangeUserFilter="(filters) => {applyFilter(filters)}"
          >
          </p-filter>
        </v-flex>
        <v-flex xs12 md6 class="text-xs-right">
          <v-layout wrap align-left>
           <v-flex xs12>
            <v-tooltip left>
              <v-icon slot="activator" @click="openLink" color="black" medium style="margin-top: -5px; margin-right: 5px; cursor:pointer">link</v-icon>
              <span>Gerar Link</span>
            </v-tooltip>
            <v-tooltip left>
              <v-icon slot="activator" @click="toggleFullScreen()" :color="icon_color" medium style="margin-top: -5px; margin-right: 40px;">remove_red_eye</v-icon>
              <span v-if="icon_color === 'gray'">Modo visualização</span>
              <span v-else>Modo padrão</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs12>
            <v-tooltip left>
              <v-btn slot="activator" small outline round color="primary" @click="initialize()" :loading="loadingReload" style="margin-right: 35px;">
                <span>Atualizar</span>
                <v-progress-linear height="4" :value="this.timeReload / this.timeReloadFull * 100" style="position: absolute; margin-top: 30px;"></v-progress-linear>
              </v-btn>
              <span>A dashboard será atualizada a cada {{Math.round(this.timeReloadFull)}} segundos</span>
            </v-tooltip>
          </v-flex>
          </v-layout>
        </v-flex>
        <v-form v-if="period_select" v-model="valid" ref="form">
          <v-dialog v-model="period_select" persistent scrollable width="500">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>
                Período
              </v-card-title>
              <v-card-text>
                <v-layout wrap justify-left align-center>
                  <v-flex elevation-1>
                    <h4>Período da DashBoard</h4>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <p-date-time label="Início"
                                     v-model="dashboard_movements.begin"
                                     :defaultHour="'00:00'"
                                     :rules="dateDiffRule(false, 'Início', dashboard_movements.begin, dashboard_movements.end)">
                        </p-date-time>
                      </v-flex>
                      <v-flex xs6>
                        <p-date-time label="Fim"
                                     v-model="dashboard_movements.end"
                                     :defaultHour="'23:59'"
                                     :rules="dateDiffRule(false, 'Fim', dashboard_movements.begin, dashboard_movements.end)">
                        </p-date-time>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mx-1" color="primary darken-1" :disabled="dashboard_movements.end === '' && dashboard_movements.begin === ''" @click="changePeriod('period')">Aplicar</v-btn>
                <v-btn class="mx-1" @click="closeFilter(2)">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </v-layout>
      <v-divider></v-divider>
      <v-layout wrap justify-center align-start>
        <v-flex xs12 md6 lg3>
          <card-working-hours :loading="loading.working_hours" :itemsProp="items.working_hours"></card-working-hours>
        </v-flex>
        <v-flex xs12 md6 lg3>
          <card-day-performance :loading="loading.day_performance" :itemsProp="items.day_performance"></card-day-performance>
        </v-flex>
        <v-flex xs12 md6 lg3>
          <card-overdue-tasks :loading="loading.overdue_tasks" :itemsProp="items.overdue_tasks"></card-overdue-tasks>
        </v-flex>
        <v-flex xs12 md6 lg3>
          <card-movements-finished-tasks :loading="loading.movements_finished_tasks" :itemsProp="items.movements_finished_tasks"></card-movements-finished-tasks>
        </v-flex>
        <v-flex xs12 lg4>
          <card-planned-tasks :loading="loading.planned_tasks" :itemsProp="items.planned_tasks"></card-planned-tasks>
        </v-flex>
        <v-flex xs12 lg4>
          <card-movements-active-tasks :loading="loading.movements_active_tasks" :itemsProp="items.movements_active_tasks"></card-movements-active-tasks>
        </v-flex>
        <v-flex xs12 lg4>
          <card-status-situation :loading="loading.status_situation" :itemsProp="items.status_situation"></card-status-situation>
        </v-flex>
        <v-flex xs12>
          <card-summary :loading="loading.summary" :itemsProp="items.summary" @changeRanking="changeRanking" ref="summary"></card-summary>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  /* eslint-disable no-unused-vars */
  import access from './../../mixin/access'
  import rules from './../../mixin/rules'
  import PDateTime from './../shared/PDateTime'
  import PFilter from '../shared/PFilter'
  import CardWorkingHours from './cards/CardWorkingHours'
  import CardDayPerformance from './cards/CardDayPerformance'
  import CardOverdueTasks from './cards/CardOverdueTasks'
  import CardMovementsFinishedTasks from './cards/CardMovementsFinishedTasks'
  import CardPlannedTasks from './cards/CardPlannedTasks'
  import CardMovementsActiveTasks from './cards/CardMovementsActiveTasks'
  import CardStatusSituation from './cards/CardStatusSituation'
  import CardSummary from './cards/CardSummary'
  import moment from 'moment'

  export default {
    mixins: [access, rules],
    data: () => ({
      dashboard_teams: [],
      entity: 'dashboard_movements',
      period: 'day',
      before_period: 'day',
      begin: '',
      end: '',
      db_change: true,
      users_loading: false,
      loadingReload: false,
      intervalReload: null,
      timeReload: 100,
      timeReloadFull: 100,
      admin: false,
      period_select: false,
      linkDialog: false,
      link: '',
      valid: false,
      permission: false,
      filter_loading: false,
      icon_color: '',
      loading: {
        working_hours: true,
        overdue_tasks: true,
        movements_finished_tasks: true,
        day_performance: true,
        summary: true,
        planned_tasks: true,
        movements_active_tasks: true,
        status_situation: true
      },
      dashboard_filter: [
        {value: 'day', text: 'Diário'},
        {value: 'week', text: 'Semanal'},
        {value: 'month', text: 'Mensal'},
        {value: 'period', text: 'Período'}
      ],
      dashboard_movements: {
        users: [],
        teams: [],
        begin: '',
        end: ''
      },
      values: [],
      dashboard_movements_all_users: [],
      dashboard_movements_users: [],
      filter: '',
      items: {
        working_hours: '',
        overdue_tasks: '',
        movements_finished_tasks: '',
        day_performance: '',
        summary: {},
        planned_tasks: [],
        movements_active_tasks: [],
        status_situation: []
      },
      setDashboardInterval: 0
    }),
    components: {PFilter, CardMovementsActiveTasks, CardSummary, CardMovementsFinishedTasks, CardOverdueTasks, CardDayPerformance, CardPlannedTasks, PDateTime, CardWorkingHours, CardStatusSituation},
    created () {
      this.permission = this.$auth.user()['admin']
      if (this.$route.query.filter) {
        this.filter = atob(this.$route.query.filter)
      }
    },
    mounted () {
      if (!document.fullscreenElement) {
        this.icon_color = 'gray'
      } else {
        this.icon_color = 'black'
      }
      this.filter_loading = true
      // E carregado as equipes atraves da requisicao 'open_dashboard' no mounted e nao so quando e clicado no filtro porque no redofilter ele precisa ter os valores antes para montar os chips
      this.$http.get(`api/open_dashboard?permission=${this.permission}`).then(res => {
        this.dashboard_teams = res.body['get_clean_teams']
        this.dashboard_movements_all_users = res.body['dashboard_users']
        this.dashboard_movements_users = JSON.parse(JSON.stringify(res.body['dashboard_users']))
        this.filter_loading = false
        // Aqui é pego os últimos valores selecionados no filtro por aquele usuário no banco de dados, pois assim é possível colocar os filtros novamente para ele continuar com sua visualização desejada
        this.values = this.$store.getters[`filter/values`]
        if (this.filter) {
          this.values[this.entity] = JSON.parse(this.filter || null) || {}
        }
        if (!this.values[this.entity]) {
          // Se não houver valores no banco, quer dizer que ele nunca selecionou filtro algum, então não tem "filtro anterior", sendo assim, um filtro padrão é acionado, sendo o "Diário"
          this.values[this.entity] = {}
          this.period = 'day'
          this.before_period = this.period
        } else {
          // Caso houver valores, é feito o filtro através da função changePeriod com os dados do último filtro selecionado
          if (this.values[this.entity]['period']) {
            if (this.values[this.entity]['begin']) this.dashboard_movements.begin = this.values[this.entity]['begin']
            if (this.values[this.entity]['end']) this.dashboard_movements.end = this.values[this.entity]['end']
            this.period = this.values[this.entity]['period']
            this.before_period = this.period
          }
          if (this.values[this.entity]['ranking']) {
            this.$refs.summary.ranking = parseInt(this.values[this.entity]['ranking'])
          }
        }
        // para verificar se o usuário é adm e pode visualizar todos os usuários
        this.beforeCustomFilter()
        this.redoFilter(false)
        // Os componentes então recebem seus valores e são inicializados
        this.loadingCards(true)
        this.initialize(['working_hours', 'overdue_tasks', 'movements_finished_tasks', 'day_performance'])
        this.initialize(['planned_tasks', 'movements_active_tasks', 'status_situation'])
        this.initialize(['summary'])
      })
      // De 15 em 15 segundos os componentes são atualizados, para manter a os gráficos da tela de dashboard em par com as alterações
      // this.setDashboardInterval = setInterval(() => {
      //   if (!this.period_select) {
      //     this.initialize()
      //   }
      // }, 15000)
      this.intervalReload = setInterval(() => {
        // timeReload vem inicialmento com timeReloadFull e depois vai perdendo 1 a cada segundo
        this.timeReload = this.timeReload - 1
        if (this.timeReload === 0) this.initialize()
      }, 1000)
    },
    methods: {
      initialize (whichDashboard = []) {
        this.loadingReload = true
        let params = `whichDashboard=${whichDashboard.length > 0 ? whichDashboard : []}&filter=${btoa(JSON.stringify(this.values[this.entity]))}`
        this.$http.get(`api/dashboard_movements?${params}`).then(res => {
          // coloca valor em todos os cards para tirar o loading e colocar o valor em cada card individual
          if (whichDashboard.length === 0) {
            whichDashboard = ['working_hours', 'overdue_tasks', 'movements_finished_tasks', 'day_performance', 'summary', 'planned_tasks', 'movements_active_tasks', 'status_situation']
          }
          whichDashboard.forEach((card) => {
            if (res.body.hasOwnProperty(card)) {
              this.items[card] = res.body[card]
              this.loading[card] = false
            }
          })
          // volta o timeReload para o total para ir decrementando
          this.timeReload = res.body['timeReload']
          // timeReloadFull define quanto o total de segundos
          this.timeReloadFull = res.body['timeReload']
          this.loadingReload = false
        },
        err => {
          this.loadingReload = false
          if (err.body.message === 'notCompany') {
            this.$store.commit('snackbar/change_values', {timeout: 12000, text: 'Para acessas os filtros, entre na empresa referente ao link.', color: 'warning', dialog: true})
            this.$router.push('/home')
          } else if (err.body.message === 'notAdmin') {
            this.$store.commit('snackbar/change_values', {timeout: 12000, text: 'Apenas os administradores da empresa ou o criador do link pode acessas esses filtros.', color: 'warning', dialog: true})
            this.$router.push('/home')
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os dados, reporte o erro.', color: 'error', dialog: true})
          }
          this.$store.commit('loader/change_dialog', false)
        })
      },
      openLink () {
        this.linkDialog = true
        let values = JSON.parse(JSON.stringify(this.values[this.entity]))
        values['company_id'] = this.$auth.user().company_id
        values['user_id'] = this.$auth.user().id
        this.link = `${window.location.hostname}/#/dashboard_movement?filter=${btoa(JSON.stringify(values))}`
      },
      copy () {
        let copyText = document.getElementById('link')
        /* Select the text field */
        copyText.select()
        /* For mobile devices */
        copyText.setSelectionRange(0, 99999)
        /* Copy the text inside the text field */
        document.execCommand('copy')
        this.$store.commit('snackbar/change_values', { text: `Link copiado para sua área de transferência!`, color: 'success', dialog: true })
      },
      changePeriod (value = 'day', openPeriod = false) {
        if (openPeriod && value === 'period') {
          // Se o valor for "period" e "openPeriod" quer dizer que o usuário deseja selecionar um período customizado, então a variável "period_select" ativa o dialog que fornecerá ao usuário os campos para selecionar um início e fim ao período desejado.
          this.period_select = true
          return ''
        }
        if (value === 'period') {
          // Caso o valor for "period" porém não for "openPeriod" quer dizer que o usuário já selecionou o período desejado, ou seja agora não deve abrir o dialog novamente, apenas efetivamente fazer a filtragem
          // É verificado então se é possível realizar a filtragem baseado na validação dos dados que ele inseriu
          if (this.$refs.form && !this.$refs.form.validate()) {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, corrija as validações antes de salvar!',
              color: 'warning',
              dialog: true
            })
            return false
          }
          // É disponibilizado ao usuário um texto informativo a respeito do filtro que ele escolheu, desde o "início" até o "fim" para ser seu ponto de referência. Uma vez que ele altere o filtro, esse texto irá mudar também.
          this.before_period = value
          // É salvo no banco de dados esse novo filtro realizado como o filtro padrão, já que foi o último feito. Caso o usuário não faça mais filtros e reinicie o sistema, esse filtro ainda estará em atividade pois pegaremos ele do banco de dados no mounted, na linha respectivamente comentada
          this.values[this.entity] = Object.assign(this.values[this.entity], {period: value, begin: this.dashboard_movements.begin, end: this.dashboard_movements.end})
          this.redoFilter()
          // Fecha o dialog da escolha de períodos uma vez que ja foi escolhido e realizado o filtro
          this.period_select = false
        } else {
          // Caso entre aqui quer dizer que ele selecionou um dos filtros padrões, sendo eles "Diário", "Semanal" e "Mensal", sendo assim os períodos são pegos dinamicamente de acordo com o respectivo dia, semana ou mês atual
          this.dashboard_movements.begin = ''
          this.dashboard_movements.end = ''
          this.before_period = value
          // É salvo no banco de dados esse novo filtro realizado como o filtro padrão, já que foi o último feito. Caso o usuário não faça mais filtros e reinicie o sistema, esse filtro ainda estará em atividade pois pegaremos ele do banco de dados no mounted, na linha respectivamente comentada
          this.values[this.entity] = Object.assign(this.values[this.entity], {period: value, begin: '', end: ''})
          this.redoFilter()
        }
      },
      closeFilter () {
        // Função que cancela o filtro customizado quando clicado em "Cancelar"
        // Fecha o modal de seleção de filtro customizado e volta o filtro para o que estava antes
        this.period_select = false
        this.period = this.before_period
      },
      loadingCards (val) {
        // Loading dos cards
        this.loading.working_hours = val
        this.loading.overdue_tasks = val
        this.loading.movements_finished_tasks = val
        this.loading.day_performance = val
        this.loading.summary = val
        this.loading.planned_tasks = val
        this.loading.movements_active_tasks = val
        this.loading.status_situation = val
      },
      clickActivatorFilter () {
        // Quando os filtros de times são ativados, se buscam os usuários do time
        this.filter_loading = true
        this.$http.get(`api/open_dashboard?permission=${this.permission}`).then(res => {
          this.dashboard_teams = res.body['get_clean_teams']
          this.dashboard_movements_all_users = res.body['dashboard_users']
          // this.filterTypes[1]['items'] = this.dashboard_movements_users
          setTimeout(() => {
            document.getElementById('pf_teams').focus()
          }, 100)
          this.filter_loading = false
        })
      },
      applyFilter (values) {
        // Aplica o filtro e carrega os dados
        if (this.permission) {
          this.dashboard_movements.users = values.users || []
        } else {
          this.dashboard_movements.users = values.users || values.users[0]
        }
        this.dashboard_movements.teams = values.teams || []
        if (values.teams && values.teams.length < 1) {
          this.dashboard_movements_users = this.dashboard_movements_all_users
        }
        // caso o o usuário muda o filtro o link tem que mudar
        if (this.$route.query.filter) this.$router.push('/dashboard_movement')
        if (this.db_change) {
          this.initialize()
        }
      },
      cancel () {
        this.linkDialog = false
      },
      changeTeams (val) {
        // Muda o time do filtro
        if (!val) {
          this.dashboard_movements_users = this.dashboard_movements_all_users
          return ''
        }
        let params = `type=${2}&teams=${val}`
        if (val.includes(0) || val.length === 0) {
          this.dashboard_movements_users = this.dashboard_movements_all_users
        } else {
          this.users_loading = true
          this.$http.get(`api/get_users_by_hierarchy?${params}`).then(res => {
            this.dashboard_movements_users = res.body
            this.users_loading = false
          })
        }
      },
      toggleFullScreen () {
        // Coloca a dashboard em modo FULLSCREEN quando selecionado o botão de visualização
        // Cada uma das linhas é necessária pois existem diferentes formas de se maximizar e algumas não funcionam em determinados navegadores, e diferentes formas também considerando o estado atual da tela a ser maximizada
        if (!document.fullscreenElement) {
          this.icon_color = 'black'
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen()
          } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen()
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen()
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
          }
        } else {
          this.icon_color = 'gray'
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
          }
        }
      },
      beforeCustomFilter () {
        // Verfiica se o usuário não tem permissao de acessar a dashboard de todos da empresa e se ele não fez algum filtro de equipe
        if (!this.permission && (!this.values[this.entity] || !Array.isArray(this.values[this.entity]['teams']) || (this.values[this.entity]['teams'].length === 0))) {
          Object.assign(this.values[this.entity], {'users': [`${this.$auth.user().id}-${this.$auth.user().company_id}`]})
          let userFilter = this.values
          this.$refs.filter.userFilter = userFilter || {}
          this.$refs.filter.filter = {}
          // verifica se existe o filtro
          if ((userFilter || {})[this.entity]) {
            this.$refs.filter.filter = userFilter[this.entity] || {}
          }
        }
      },
      changeRanking (val) {
        // Atualiza o valor do ranking no banco e nos filtros
        this.values[this.entity] = Object.assign(this.values[this.entity], {ranking: val})
        this.$refs.filter.filter = this.values[this.entity]
        this.$refs.filter.changeUserFilter()
      },
      redoFilter (dbChange = true) {
        // Usado para executar o filtro padrão do usuário. Assim é carregado todos os valores para o filtro funcionar
        // É usado um get para buscar o user pois this.$auth.user() não busca o filtro do usuário atualizado
        let filterInterval = setInterval(() => {
          // setInterval para verificar quando termina de carregar o filtro do usuário
          if (this.values) {
            if (this.$refs.filter) {
              // if (!this.permission && (!this.values['teams'] || this.values['teams'].length < 1)) {
              // this.values['users'] =
              // }
              let userFilter = this.values
              this.$refs.filter.userFilter = userFilter || {}
              this.$refs.filter.filter = {}
              // verifica se existe o filtro
              if ((userFilter || {})[this.entity]) {
                this.$refs.filter.filter = userFilter[this.entity] || {}
              }
              this.$refs.filter.oldFilter = JSON.parse(JSON.stringify(this.$refs.filter.filter))
              if (Object.keys(this.$refs.filter.filter).length > 0) {
                this.db_change = dbChange
                this.$refs.filter.customFilter(null, dbChange, false)
              }
            }
            // Desabilita o loading
            clearInterval(filterInterval)
          }
        }, 100)
      }
    },
    computed: {
      filterTypes: function () {
        return [
          {field: 'teams', label: 'Equipes', type: 'array', items: this.dashboard_teams, text: 'id_text', value: 'id', loading: this.filter_loading, disabled: this.filter_loading, not_close: !this.permission, not_empty: !this.permission},
          {field: 'users', label: 'Usuários', type: 'array', items: this.dashboard_movements_users, text: 'id_text', value: 'id', loading: this.users_loading, disabled: (this.filter_loading || this.users_loading), not_close: !this.permission, not_empty: !this.permission}
        ]
      }
    },
    destroyed () {
      clearInterval(this.setDashboardInterval)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardMovements.vue